import { fetchTelegramIdentityRequest } from '../fetch-telegram-identity-request';
import type { IGetTelegramOidcLinkResponse } from './get-telegram-oidc-link-response';
import { getTelegramOidcLinkResponseSchema } from './get-telegram-oidc-link-response';

export async function getTelegramOidcLinkApi(): Promise<IGetTelegramOidcLinkResponse> {
  const response = await fetchTelegramIdentityRequest('/telegram/oidc/link', {
    method: 'GET',
  });
  if (!response.ok) {
    throw new Error(`Telegram OIDC status fetch failed: ${response.status}`);
  }
  const json = await response.json();
  return getTelegramOidcLinkResponseSchema.parse(json);
}
